// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.liJ16YgDMJgVay4WrFPi {
  position: fixed;
  inset: 0;
  z-index: var(--dry-modal-zindex);
  background-color: var(--dry-modal-fade);
  display: flex;
  justify-content: center;
  align-items: center;
}
.liJ16YgDMJgVay4WrFPi {
  animation: appear 0.4s linear 1;
}
.nCq60plFwJGcqFbL5rdv {
  background-color: var(--dry-bg);
  border-radius: var(--dry-border-radius);
  padding: 1.5em;
  --dry-shadow: rgba(0, 0, 0, 0.4) 0px 30px 90px;
  box-shadow: var(--dry-shadow);
  position: relative;
}
.nCq60plFwJGcqFbL5rdv footer {
  display: flex;
  flex-direction: row;
  justify-content: right;
  gap: 1em;
  margin-top: 2em;
}
._A7jpqRlT7DbfOsq4V9S {
  position: absolute;
  top: 0.5em;
  right: 1em;
  font-size: 1.2em;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: var(--dry-color);
  opacity: 0.6;
}
._A7jpqRlT7DbfOsq4V9S:hover {
  opacity: 1;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `liJ16YgDMJgVay4WrFPi`,
	"dialog": `nCq60plFwJGcqFbL5rdv`,
	"close": `_A7jpqRlT7DbfOsq4V9S`
};
export default ___CSS_LOADER_EXPORT___;
